import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { accessRows, accessChecks } from '../../data/instantAccess';
export function InstantAccess() {
  return <section className="bg-white py-14 sm:py-16" data-id="element-128" data-mp="39dq55tozbejc">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-129" data-mp="34bsggjxt7rj0">
        <SectionTag icon="📦" data-id="element-130" data-mp="30ays5pgggapl">Acceso inmediato</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-131" data-mp="30cjljbr19nlv">
          Esto lo recibes en tu correo hoy mismo.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-gris-texto sm:text-lg" data-id="element-132" data-mp="2qkm6ftwwmbhv">
          Material profesional descargable al instante, sin esperar envíos.
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-2xl px-6 sm:px-8" data-id="element-133" data-mp="2gnrclobksz9x">
        <ScrollHintTable minWidth="420px" data-id="element-134" data-mp="2gpc4t7af464m">
          <table className="w-full text-left text-sm" data-id="element-135" data-mp="2cle6uzwtx1d5">
            <thead data-id="element-136" data-mp="2cnqwlz8twg0r">
              <tr className="border-b border-gris-claro bg-bg-secondary text-xs uppercase tracking-wide text-gris-muted" data-id="element-137" data-mp="35oooq6jz8bwp">
                <th className="px-5 py-3 font-semibold" data-id="element-138" data-mp="3afon7g8qv21b">Formato</th>
                <th className="px-5 py-3 font-semibold" data-id="element-139" data-mp="2vqiri2947ty6">Contenido</th>
                <th className="px-5 py-3 font-semibold" data-id="element-140" data-mp="2vsbzplzdmm8a">Páginas</th>
              </tr>
            </thead>
            <tbody className="bg-white" data-id="element-141" data-mp="30pvfwrfmx92v">
              {accessRows.map((row, i) => <tr key={row.content} className={i !== accessRows.length - 1 ? 'border-b border-gris-claro' : ''} data-id="element-142" data-mp="3ofpr74kb2pl0" data-mpi={i}>
                  <td className="whitespace-nowrap px-5 py-4 text-marino" data-id="element-143" data-mp="3tc6lyhm0g272">{row.format}</td>
                  <td className="px-5 py-4 text-gris-texto" data-id="element-144" data-mp="3fe8d1rqgkxyy">{row.content}</td>
                  <td className="whitespace-nowrap px-5 py-4 font-semibold text-naranja" data-id="element-145" data-mp="3jes54gw6dbe8">{row.pages}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>

        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-146" data-mp="282hnn6mvt1p3">
          {accessChecks.map(check => <div key={check} className="flex items-center gap-2 text-sm text-gris-texto" data-id="element-147" data-mp="eka9yvsbfikf">
              <CheckIcon size={16} className="text-verde" data-id="element-148" data-mp="9jwbo5ginmzl" />
              {check}
            </div>)}
        </div>
      </div>
    </section>;
}